import { render } from "./ShareOverlay.vue?vue&type=template&id=2701f586&scoped=true"
import script from "./ShareOverlay.vue?vue&type=script&lang=js"
export * from "./ShareOverlay.vue?vue&type=script&lang=js"

import "./ShareOverlay.vue?vue&type=style&index=0&id=2701f586&lang=scss&scoped=true"

import exportComponent from "/Users/christianwidodo/workspace_git/lionsgate/tuwomt/cagespace-site/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2701f586"]])

export default __exports__